import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React from "react";
import { number, object, string } from "yup";
import { FinalConfirmationRequest } from "../../models/settlement.model";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxWidth: "500px",
  //   maxHeight: "70vh",
  minHeight: "15vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const validation = object().shape({
  sayadNumber: number().min(16, "شماره صیاد باید 16 رقم باشد."),
  cheaqueSeries: number(),
  cheaqueSerial: number(),
  description: string()
    .ensure()
    .max(500, "توضیحات نباید بیش از 500 کاراکتر باشد."),
});

interface Props {
  open: boolean;
  setOpen: (arg: boolean) => void;
  handleSubmition: Function;
  handleClose: Function;
  amount: number;
}

const OnlineSettlementConfirmModal = ({
  open,
  setOpen,
  handleSubmition,
  handleClose,
  amount,
}: Props) => {
  const initialValues: Pick<FinalConfirmationRequest, "description"> = {
    description: "",
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Box sx={{ width: "100%", marginBottom: "15px" }}>
          <Typography sx={{ fontSize: "1rem", textAlign: "center" }}>
            آیا از ثبت تسویه از طریق{" "}
            <span style={{ color: "#1565C0" }}>انتقال وجه بانکی</span> با مبلغ{" "}
            <span style={{ color: "#1565C0" }}>
              {amount.toLocaleString("fa")} ریال
            </span>{" "}
            اطمینان دارید؟
          </Typography>
        </Box>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => handleSubmition(values)}
          validateOnMount={true}
          validationSchema={validation}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
          }) => (
            <form
              onSubmit={handleSubmit}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <Grid container xs={12}>
                <Grid
                  container
                  xs={12}
                  spacing={2}
                  style={{ paddingBottom: "20px" }}
                ></Grid>
                <Grid
                  container
                  xs={12}
                  spacing={2}
                  style={{ paddingBottom: "20px" }}
                >
                  <Grid item xs={12} sx={{ paddingLeft: "0px !important" }}>
                    <MaterialTextFieldComponent
                      placeHolder={"توضیحات"}
                      label={"توضیحات"}
                      name={"description"}
                      id={"description"}
                      value={values.description}
                      onChange={handleChange}
                      helperText={touched.description ? errors.description : ""}
                      error={touched.description && Boolean(errors.description)}
                      onBlur={handleBlur}
                      multiline
                      className={"heightTextField"}
                      sx={{
                        "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                          fontSize: 13,
                          lineHeight: "2vh !important",
                          height: "6vh !important",
                        },

                        "& .MuiInputBase-root": {
                          height: "14vh !important",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  justifyContent={"center"}
                  alignItems={"center"}
                  marginBottom={"8px"}
                >
                  <Grid
                    item
                    xs={6}
                    width={"100%"}
                    sx={{ paddingInline: "10px" }}
                  >
                    <Button
                      fullWidth
                      type='submit'
                      variant='contained'
                      className={"btnForm SuccessDefault"}
                    >
                      تایید و تسویه حساب
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    width={"100%"}
                    sx={{ paddingInline: "10px" }}
                  >
                    <Button
                      onClick={() => handleClose()}
                      fullWidth
                      variant='contained'
                      style={{
                        fontSize: "1rem",
                        color: "#fff",
                        height: "40px",
                        background: "#607D8B",
                      }}
                    >
                      بازگشت
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default OnlineSettlementConfirmModal;
